import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { IReception, IReceptionValidation, AppointmentStatus, ISearchComponent, IPermission } from "@/models";
import DatePicker from "vue2-datepicker";
import moment from "moment";
import { ToastHelper } from "@/helpers/ToastHelper";
import vSelect from "vue-select";

@Component({
    name: "receptiondelivery",
    components: {
        "datepicker": DatePicker,
        "v-select": vSelect,
    },
})

export default class ReceptionDelivery extends Vue {
    public readonly modalDeleteReception: string = "modalDeleteReception";
    public effectiveArrival: string = "";

    public editDateExpectedArrival: string = "";
    public editTimeExpectedArrival: string = "";

    public editMode: boolean;

    public internalReception: IReception = null;

    public toto = null;

    public constructor() {
        super();

        this.editMode = false;
    }

    public created(): void {
        this.initInternalReception();
    }

    public get notBefore(): Date {
        return moment().hours(0).minutes(0).seconds(0).toDate();
    }

    public get reception(): IReception {
        return this.$store.getters["receptions/getSelectedReception"]();
    }

    public get canGoValidation(): boolean {
        return (this.reception.status === AppointmentStatus.InProgress && this.reception.receptionComponents.length !== 0) ||
            this.reception.status === AppointmentStatus.Unexpected;
    }

    public get searchComponents(): ISearchComponent[] {
        return this.$store.getters["components/getSearchComponents"]();
    }

    public get permission(): IPermission {
        return this.$store.state.user.permission;
    }

    public goBackward(): void {
        this.$router.back();
    }

    public goValidation(): void {
        // MAJ effectiveDate

        if (this.effectiveArrival !== "") {
            this.internalReception.effectiveArrival = moment(this.effectiveArrival).toISOString(true);
            this.$store.commit("receptions/EDIT_SELECTED_RECEPTION", this.internalReception);

            this.$router.push({ name: "receptionValidation" });
        } else {
            ToastHelper.general.invalidModel();
        }
    }

    public deleteReception(): void {
        this.$store.dispatch("receptions/deleteReception", this.reception.receptionId)
            .then(() => {
                this.goBackward();
            });
    }

    public editReception(): void {
        this.internalReception.expectedArrival = moment(this.editDateExpectedArrival + " " + this.editTimeExpectedArrival).toISOString(true);

        this.$store.dispatch("receptions/editReception", this.internalReception)
            .then(() => {
                this.editMode = false;
            });
    }

    public searchComponent(search, loading): void {
        if (search.length >= 3) {
            loading(true);

            this.$store.dispatch("components/fetchComponentWithPrefix", search).then(() => {
                loading(false);
            });
        }
    }

    public addReceptionComponent(): void {
        this.internalReception.receptionComponents.push({
            receptionComponentId: 0,
            quantity: 0,
            nbPallet: 0,
            observations: "",
            receptionId: 0,
            componentId: 0,
            isFirstArrival: false,
            component: {
                componentId: 0,
                code: "",
                description: "",
            },
        });
    }

    public deleteLine(index: number): void {
        this.internalReception.receptionComponents.splice(index, 1);
    }

    @Watch("reception")
    public onReceptionChanged(value: IReception, oldValue: IReception) {
        this.initInternalReception();
    }

    public initInternalReception(): void {
        if (this.reception.effectiveArrival !== null) {
            this.effectiveArrival = moment(this.reception.effectiveArrival).format("YYYY-MM-DD HH:mm");
        }
        else {
            this.effectiveArrival = moment().format("YYYY-MM-DD HH:mm");
        }

        this.internalReception = {
            ...this.reception,
            receptionComponents: this.reception.receptionComponents.map(rc => {
                return {
                    ...rc,
                    component: { ...rc.component },
                };
            }),
        };

        this.editDateExpectedArrival = moment(this.internalReception.expectedArrival).format("YYYY-MM-DD");
        this.editTimeExpectedArrival = moment(this.internalReception.expectedArrival).format("HH:mm");
    }
}
